import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { lt, FormTextareaField, useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ReservationLinkResult } from '@mews-commander/data-access';
import { useGetPaymentPlanLocalizedDates } from '../hooks';
import { CreatePaymentPlanFormValues } from '../schema';
import { CreatePaymentPlanFormField } from '../types';

export const CreatePaymentPlanDialogFormPaymentRequestMessageField = ({
    reservation,
}: {
    reservation: ReservationLinkResult;
}) => {
    const localizeText = useLocalizeText();
    const { firstPaymentRequestDate, firstScheduledPaymentDate } = useGetPaymentPlanLocalizedDates(reservation);
    const { getFieldState, setValue } = useFormContext<CreatePaymentPlanFormValues>();

    const message = localizeText({
        textKey: TextKey.CreatePaymentPlanFormPaymentRequestMessageValueWithDates,
        substitutes: { firstPaymentRequestDate, firstScheduledPaymentDate },
    });

    useEffect(() => {
        const { isDirty } = getFieldState(CreatePaymentPlanFormField.Message);
        if (isDirty) {
            return;
        }

        setValue(CreatePaymentPlanFormField.Message, message);
    }, [getFieldState, setValue, message]);

    return (
        <FormTextareaField
            name={CreatePaymentPlanFormField.Message}
            label={lt('CreatePaymentPlanFormPaymentRequestMessageLabel')}
            rows={4}
            required
        />
    );
};
